import { BREAKPOINTS } from 'foundations-components/transitional/components/Grid';
export const device = {
  mobile: `(max-width: ${BREAKPOINTS.sm}px)`,
  tablet: `(max-width: ${BREAKPOINTS.md}px)`,
  laptop: `(max-width: ${BREAKPOINTS.lg}px)`,
  desktop: `(min-width: ${BREAKPOINTS.xl}px)`,
  not: {
    mobile: `(min-width: ${BREAKPOINTS.sm}px)`,
    tablet: `(min-width: ${BREAKPOINTS.md}px)`,
    laptop: `(min-width: ${BREAKPOINTS.lg}px)`
  }
};